// eslint-disable-next-line spaced-comment
/// <reference types="resize-observer-browser" />

import React, { ReactNode } from 'react';
import { debounce } from '../../../CodesThatsGottaGoSomewhereElse';
import { Point } from '../../../platform/geom/Point';
import { Fill } from '../../../ui/Fill';
import { ContainerScope, resolve } from '../../Container';
import { Camera } from '../Camera';

export class CanvasView extends React.Component<{ children?: ReactNode }> {

    public static contextType = ContainerScope;

    @resolve(Camera) private camera!: Camera;

    private outer = React.createRef<HTMLDivElement>();
    private inner = React.createRef<HTMLDivElement>();
    private ready = false;
    private obsvr = null as ResizeObserver;

    public render() {
        return <Fill ref={this.outer} onScroll={this.onScroll} overflow="hidden">
            <Fill id="canvas" ref={this.inner}>
                {this.ready && this.props.children}
            </Fill>
        </Fill>;
    }

    public componentDidMount() {
        const obs = new ResizeObserver(debounce(this.calibrate, 100));
        obs.observe(this.outer.current);
        this.calibrate();
        this.ready = true;
        this.forceUpdate();
    }

    public componentWillUnmount() {
        this.obsvr?.disconnect();
    }

    private onScroll = () => {
        const { camera, outer } = this;
        // Convert any scrolling into camera movement
        const vec = new Point(outer.current.scrollLeft, outer.current.scrollTop);
        camera.move(vec);
        outer.current.scrollTo(0, 0);
    };

    private calibrate = () => {
        const i = this.inner.current;
        const o = this.outer.current;
        if (i && o) {
            // This is important to stop rendering jank when screen is odd width/height
            i.style.width = `${o.clientWidth + (o.clientWidth % 2)}px`;
            i.style.height = `${o.clientHeight + (o.clientHeight % 2)}px`;
            this.camera.calibrate(this.inner.current);
        }
    };
}
